import AccountAccessArea from "../enums/AccountAccessArea";

export default function isAccessPermitted(areas:string[], targetArea:AccountAccessArea) {
    return areas && areas.includes(targetArea.toString());
}
